import { isLayerNotAbleToChangeExtreme } from '../utils/unitConversion';

const ExtremeMixin = SuperClass => class UnitUpdatable extends SuperClass {
  constructor({
    player,
    timeBucketMs = 1,
    preloadTimeMs = 0,
    ...options
  }) {
    if (typeof SuperClass.prototype.updateParams !== 'function') {
      throw new TypeError(`Invalid base class: "${SuperClass.name}" not support "updateParams" method`);
    }

    if (!player) {
      throw new TypeError(`Failed to construct UnitUpdatable class base on "${SuperClass.name}": "player" argument required`);
    }

    if (typeof player.addEventListener !== 'function' || !Object.prototype.hasOwnProperty.call(player, 'currentTime')) {
      throw new TypeError('Invalid "player" instance.');
    }

    super({
      player,
      timeBucketMs,
      preloadTimeMs,
      ...options
    });
    this.player = player;
    this.player.addEventListener('extremumupdate', this.extremeUpdate.bind(this));
  }

  extremeUpdate(e) {
    if (!isLayerNotAbleToChangeExtreme(this.params.element)) {
      return;
    }

    this.updateParams({
      plot_extrema: e.detail.plot_extrema
    });
  }

};

export default ExtremeMixin;